export async function request(endpoint, options = {}) {
  const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;
  try {
    const token = localStorage.getItem("token");
    const headers = {
      "Content-Type": "application/json",
      ...options.headers,
    };
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      method: options.method || "GET",
      headers,
      body: options.body ? JSON.stringify(options.body) : null,
    });
    if(response.status === 401 || response.status === 403) {
      window.location.href = '/login'
    }
    const result = await response.json();
    if(!response.ok) {
      throw new Error(result.error);
    }
    return result;
  } catch (err) {
    return Promise.reject(err);
  }
}
